// 设备管理接口
import request from '@/utils/request.ts'

export const getEquipment = (params: any) =>
  request({
    url: '/equipment',
    method: 'get',
    params
  })
